// extracted by mini-css-extract-plugin
export var activeDot = "_51-c";
export var buttonContainer = "_51-9";
export var channelButton = "_51-a";
export var clickable = "_51-d";
export var content = "_51-0";
export var contentFull = "_51-2";
export var contentThird = "_51-1";
export var contentWrapper = "_51-7";
export var description = "_51-5";
export var heightShort = "_51-f";
export var image = "_51-3";
export var imageContainer = "_51-4";
export var selectButton = "_51-e";
export var spinnerContainer = "_51-b";
export var titleContent = "_51-8";
export var titleWrapper = "_51-6";